<template>
  <div id="repNav">
    <div class="logo">
    <!-- <a href="#" v-if="isEnrollPrime"> <img src="https://corenroll-logo.s3.us-east-2.amazonaws.com/light-nuera.png" alt="enroll-prime" width="160"></a> -->
    <!-- <a href="#" v-else> <img src="../assets/images/corenroll_logo_dark.svg" class="corenroll-logo" alt="corenroll-logo"></a> -->
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
      name: "Header.vue",
      computed: {
        ...mapGetters({ isEnrollPrime: "isEnrollPrime" }),
      }
    }
</script>